import { z } from 'zod'
import { SuppliedPassword } from './password'
import { MeUser } from './me'

export const AUTH_PATHS = {
  signIn: '/v1/auth/sign-in',
  signOut: '/v1/auth/sign-out',
  session: '/v1/auth/session',
  password: '/v1/me/password',
} as const

export const SIGN_IN_FAILED_MESSAGE = '帳號或密碼錯誤'
export const CURRENT_PASSWORD_INCORRECT_MESSAGE = '目前的密碼不正確'
export const NEW_PASSWORD_SAME_MESSAGE = '新密碼不可以和目前的密碼一樣'
export const INVITE_PASSWORD_REQUIRED_MESSAGE = '這個 email 還沒有登入帳號，請先為對方設定一個臨時密碼。'
export const INVITE_OPERATOR_REFUSED_MESSAGE = '這個 email 屬於平台營運人員，不能邀請加入工作區。'
export const CROSS_ORIGIN_REFUSED_MESSAGE = '這個請求不是由回覆助手發出的，已被拒絕。'

export const SignInRequest = z.strictObject({ email: z.email(), password: SuppliedPassword })
export type SignInRequest = z.infer<typeof SignInRequest>

export const AuthSession = z.object({ user: MeUser })
export type AuthSession = z.infer<typeof AuthSession>

export const SignOutResponse = z.object({ signedOut: z.literal(true) })
export type SignOutResponse = z.infer<typeof SignOutResponse>
